import { RemoteListDataSource, RemoteOneDataSource } from "lego-gui-lib";

export type DataSourceWithDownload = RemoteListDataSource<any, any> &
  RemoteOneDataSource<any, any> & {
    downloadData: (row: any) => Promise<void>;
  };

export const DataDownloadMixin = (
  ds: RemoteOneDataSource<any, any> | RemoteListDataSource<any, any>
): DataSourceWithDownload => {
  // @ts-ignore
  ds.downloadData = async (row: any) => {
    ds.executeRemote("downloadData", async () => {
      const url = ds.url + "/" + ds.schema.link(row) + "/announcement";
      await ds.api.fileDownload(url);
    });
  };

  return ds as DataSourceWithDownload;
};
